import {
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';

export interface IntakeFormSettingsState {
  value: any;
}

const initialState: IntakeFormSettingsState = {
  value: null,
};

export const intakeFormSettingsSlice = createSlice({
  name: 'intakeFormSettings',
  initialState,
  reducers: {
    intakeFormSettingsAction: (state, action: PayloadAction<any>) => {
      state.value = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { intakeFormSettingsAction } = intakeFormSettingsSlice.actions;

export default intakeFormSettingsSlice.reducer;
